import { render, staticRenderFns } from "./TournamentGraphs.vue?vue&type=template&id=6f10df0a&scoped=true"
import script from "./TournamentGraphs.vue?vue&type=script&lang=js"
export * from "./TournamentGraphs.vue?vue&type=script&lang=js"
import style0 from "./TournamentGraphs.vue?vue&type=style&index=0&id=6f10df0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10df0a",
  null
  
)

export default component.exports